/**
 * Year navigation header — ◀ 2026-yil ▶ with goal count badge.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface YearNavHeaderProps {
  year: number
  onPrev: () => void
  onNext: () => void
  goalCount: number
}

export const YearNavHeader: React.FC<YearNavHeaderProps> = ({
  year, onPrev, onNext, goalCount,
}) => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-1">
        <motion.button
          whileTap={{ scale: 0.85 }}
          onClick={onPrev}
          className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/[0.06] transition-colors tap-highlight-transparent"
          aria-label="Previous year"
        >
          <ChevronLeft size={18} className="text-text-hint" />
        </motion.button>

        <span className="text-lg font-display font-bold text-text min-w-[90px] text-center">
          {t('goals.yearLabel', { year })}
        </span>

        <motion.button
          whileTap={{ scale: 0.85 }}
          onClick={onNext}
          disabled={year >= currentYear + 5}
          className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/[0.06] transition-colors tap-highlight-transparent disabled:opacity-30"
          aria-label="Next year"
        >
          <ChevronRight size={18} className="text-text-hint" />
        </motion.button>
      </div>

      {goalCount > 0 && (
        <span className="text-xs font-medium text-text-hint bg-white/[0.06] px-2.5 py-1 rounded-full">
          {t('goals.goalCount', { count: goalCount })}
        </span>
      )}
    </div>
  )
}
